



















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		state: {
			type: String,
			required: true,
		},
		timestamp: {
			type: String,
			required: true,
		},
		handleClick: {
			type: Function,
			required: false,
			default: () => {
				/* noop */
			},
		},
	},
});
